import { render, staticRenderFns } from "./fai-le-tue-scelte-cookie.vue?vue&type=template&id=25541430"
import script from "./fai-le-tue-scelte-cookie.vue?vue&type=script&lang=js"
export * from "./fai-le-tue-scelte-cookie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports